import styled, { css } from "styled-components";

export const Container = styled.div`
  width: 100%; // 31rem
  height: 100%; // 22rem
  display: flex;
  flex-direction: column;
  user-select: none;
  position: relative;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 17.8%; // 3.9rem
  background-color: #c6c7c8;
  border-radius: 8.44531px 8.44531px 0px 0px;
  box-sizing: border-box;
  padding-right: 55px;
  padding-left: 10px;
  position: relative;

  .react-datepicker-popper {
    z-index: 3000;
  }
  .react-datepicker__tab-loop {
    position: absolute;
  }
`;
export const HeaderIcon = styled.div`
  margin-top: 0.5rem;
`;
export const HeaderTitle = styled.span`
  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 0.95rem;
  line-height: 1.2rem;
  color: #212326;
`;

export const ScrollBarModifier = styled.div`
  box-sizing: border-box;
  padding: 0 4px;
  height: 100%;
  width: 100%;
  background-color: #fff;
`;

export const TableContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: scroll;

  ::-webkit-scrollbar {
    width: 12px; // Adjust the scrollbar width
  }

  ::-webkit-scrollbar-track {
    //background: #f1f1f1; // The track of the scrollbar
    margin-top: 1.2rem;
    margin-bottom: 0.2rem;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #888; // The scroll handle color
    border-radius: 10px; // Round corners of the scroll handle
    border: 3px solid #f1f1f1; // Matching the track
  }
`;

export const Table = styled.table`
  width: 100%;
  height: 100%; // Adjust as needed%
  overflow-y: scroll;
  border-collapse: collapse;
`;

export const ScrollableTBody = styled.tbody`
  height: 100%;
  width: 100%;
  background-color: #fff;

  td {
    font-size: 15px;
    text-align: center;
  }
  tr {
    height: 4rem;
  }
`;

export const TableHeader = styled.thead`
  height: 10%;

  font-size: 12px;

  th {
    position: sticky;
    top: 0; // Adjust this value if necessary to account for any other fixed elements like a top navbar
    background: #fff; // Ensure the header has a background so it isn't see-through when scrolling
    z-index: 10; // Ensure the header is above other elements when scrolling
  }
`;

export const Icon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  img {
    width: 2.25rem;
    height: auto; // Maintain aspect ratio
    border-radius: 50%;
    border: 1px solid #40e5a0;
  }

  path {
    stroke: #a9aeb4;
  }
`;

export const TaskCounter = styled.span`
  padding: 0.2rem 0.7rem;
  border-radius: 0.2rem;
  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 0.74rem;
  line-height: 0.95rem;

  background-color: ${({ status }) =>
    status === "doing"
      ? "#F8E47C"
      : status === "done"
      ? "#118052"
      : status === "doneLate"
      ? "#9F2D1D"
      : status === "pending"
      ? "#EFF1F5"
      : status === "late"
      ? "#FFBAAB"
      : ""};

  color: ${({ status }) =>
    status === "doing"
      ? "#786A23"
      : status === "done" || status === "doneLate"
      ? "#EFF1F5"
      : status === "pending"
      ? "#7E858F"
      : status === "late"
      ? "#D93333"
      : ""};
`;

//? Toggle COmponent

export const Toggle = styled.div`
  width: 12rem;
  height: 2rem;
  display: flex;

  background: #ffffff;
  border: 0.07rem solid #d4d6da;
  box-sizing: border-box;
  border-radius: 0.4rem;
  align-items: center;
  position: relative;
`;

export const ToggleTest = styled.div`
  position: absolute;
  width: 49%;
  height: 85%;
  border-radius: 0.4rem;
  background-color: #40e5a0;
  left: ${({ toggleState }) => (toggleState === "semanal" ? "1%" : "50%")};
  pointer-events: none;
  z-index: 1;
  transition: 0.2s ease-out;
`;

export const ToggleMinhasTarefas = styled.div`
  width: 49%;
  height: 85%;
  margin-left: 1%;
  border-radius: 0.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 0.75rem;
  line-height: 0.95rem;
  color: #585e66;

  //animation block
  z-index: 2;
  user-select: none;
  cursor: pointer;
`;

export const ToggleTodasTarefas = styled.div`
  width: 49%;
  height: 85%;
  margin-right: 1%;
  border-radius: 0.4rem;
  display: flex;
  justify-content: center;
  align-items: center;

  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 0.75rem;
  line-height: 0.95rem;
  color: #585e66;
  //animation block
  z-index: 2;
  user-select: none;
  cursor: pointer;
`;

export const RefreshContainer = styled.div`
  position: absolute;
  right: 0.5rem;
  top: 0.5rem;
`;

export const CustomDatePickerInput = styled.button`
  width: 100px;
  height: 2rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: ${(props) =>
    props.isSelected ? "#42464c" : "auto"}; // #42464c / #212326
  padding: 0 5px; // Remove any default padding
  border: none; // Remove default border
  outline: none; // Remove focus outline
  box-shadow: none; // Remove any shadow effects
`;

export const DatePickerDisplay = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const FilterButton = styled.button`
  ${({ sortBy }) =>
    sortBy &&
    css`
      background-color: #40e5a0;
      color: #fff;
      border: none;
      border-radius: 4px;
      font-weight: bold;
      border: 1px solid #40e5a0;
    `}
`;
